import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {StyleType} from '@catui/types';

const componentBaseName = 'form-group-container';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-form-group-container',
  templateUrl: './form-group-container.component.html',
  styleUrls: ['./form-group-container.component.scss'],
})
export class FormGroupContainerComponent implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;
  @Output() submitted = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() clone = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() reset = new EventEmitter();
  @Output() create = new EventEmitter();

  @Input() displayCreate: boolean = false;
  @Input() displayDelete: boolean = false;
  @Input() displayUpdate: boolean = false;
  @Input() displayClone: boolean = false;
  @Input() displayReset: boolean = false;
  @Input() isValid: boolean;
  @Input() isDirty: boolean;
  @Input() type = Type.Default;
  @Input() submitLabel = 'Save';
  @Input() inline: boolean = false;
  @Input() hideFooter: boolean = false;

  TypeInfo = Type;
  StyleType = StyleType;

  ngOnInit() {
  }

  submitForm($event) {
    this.submitted.emit($event);
  }
  onDelete($event) {
    this.delete.emit($event);
  }
  onClone($event) {
    this.clone.emit($event);
  }
  onReset($event) {
      this.reset.emit($event);
  }
  onUpdate($event) {
    this.update.emit($event);
  }
  onCreate($event) {
    this.create.emit($event);
  }
}

export const Type = {
  Default: 'default',
  MultiPanel: 'multi-panel',
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/form-group-container/form-group-container.component.ts